module.exports = __webpack_public_path__ + "img/mail.png?e6359405c78559666812e9ca9560e7c7";